<template>
    <div 
        class="h-100"
        v-tinymce="options"
        :key="renderKey"
        @mce-change="(contact) => offerSectionSet({contactPerson: contact})"
        @mce-dirty="() => $emit('dirty')"
    >
        <component 
            v-if="offerSections.contactPerson" 
            :imageUrl="imageUrl" 
            :is="{
                props: {
                    imageUrl: String
                },
                template: offerSections.contactPerson
            }"
        ></component>
        <b-card v-else class="contact-person">
            <h5>{{ $t('contactPerson.heading') }}</h5>
            <b-row>
                <b-col sm="4" v-if="contactMail !== 'yavuz@gfu.net'">
                    <div class="contact-image">
                        <img :src="imageUrl" :alt="contactName">
                    </div>
                </b-col>
                <b-col :sm="contactMail !== 'yavuz@gfu.net' ? 8 : 12">
                    <b>{{ contactName }}</b>
                    <div>
                        <span>{{ $t('contactPerson.phone') }}</span><br>
                        <span>{{ contactPhone }}</span>
                    </div>

                    <div>
                        <span>{{ $t('contactPerson.fax') }}</span><br>
                        <span>0221 82 80 9 - 50</span>
                    </div>

                    <a :href="mailTo" data-gtm-mail-contact>{{ contactMail }}</a><br>
                    <!-- :class="{'online': isChatOnline}" -->
                    <a 
                        class="chat-indicator" 
                        href="#"
                        @click.prevent="openChat()"
                        data-gtm-chat-contact
                    >
                        {{ $t('actions.liveChat') }}
                    </a>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import Config from '../../misc/Config';
import placeholder from './placeholder';

export default {
    name: 'ContactPerson',
    props: {
        options: Object,
    },
    mixins: [placeholder],
    data() {
        return {
            renderKey: 0,
        }
    },
    computed: {
        ...mapGetters([
            'employee',
            'offerSections',
        ]),
        imageUrl: function () {
            return this.employee
                ? Config.GFU_API_URL.replace(/\/api$/, '') + this.employee.imageUrl
                : this.placeholderImg;
        },
        contactName: function () {
            return this.employee
                ? this.employee.firstName + ' ' + this.employee.lastName
                : this.placeholder;
        },
        contactPhone: function () {
            return this.employee
                ? this.employee.phone
                : this.placeholder;
        },
        mailTo: function () {
            return this.employee
                ? 'mailto:' + this.employee.email
                : '#'
        },
        contactMail: function () {
            return this.employee
                ? this.employee.email
                : this.placeholder;
        }
    },
    methods: {
        ...mapMutations([
            'offerSectionSet'
        ])
    },
    watch: {
        employee: function() {
            this.renderKey++;
        }
    }
}
</script>

<style scoped>
    .contact-person {
        height: 100%;
    }

    .contact-image {
        width: 100px;
        height: 100px;
        border-radius: 50%;
        border-top-right-radius: 0;
        overflow: hidden;
    }

@media screen and (min-width:890px) and (max-width:1100px) {
    .contact-image {
        width: 80px;
        height: 80px;

    }
}

@media screen and (min-width:768px) and (max-width:889px) {
    .contact-image {
        width: 60px;
        height: 60px;

    }
}

    .contact-image img {
        min-height: 100%;
    }
</style>
